import React from 'react'
import { Helmet } from "react-helmet";
import HeroSection from './HeroSection'
import SlideUpCards from './SlideUpCards'
import ChoosePackky from './ChoosePackky'
import PackkyWorks from './PackkyWorks'
import CodeStrength from './CodeStrength'
import FourCards from './FourCards'
import OurService from './OurService'
import OurBlog from './LatestBlogs'
import Footer from './Footer'
import Updates from './Updates'
import Navbar from './Navbar'
import ClientReviews from '../EnterPrise/ClientReviews'


const App = () => {
  return (
    <>
      <Helmet>
        <title>  Packky — Smart Delivery Management Software for Restaurants & Businesses in India</title>

        <meta
          name="description"
          content=" Packky by Chaafo helps restaurants and businesses manage last-mile deliveries with smart route optimization, live tracking, and flexible vehicle options. Start today."
        />
      </Helmet>
    <Navbar />
   <HeroSection />  
   <SlideUpCards />
   <ChoosePackky />
   <PackkyWorks />
   <CodeStrength />
   <Updates />
   <FourCards />
   <OurService />
   <ClientReviews />
   <OurBlog />
   <Footer />
    </>
  )
}

export default App
